import { defineComponent, ref, onMounted, onBeforeUnmount, computed, nextTick, watch } from 'vue';
import sys from '@truckdown/jsclient';
import * as icons from '@truckdown/jsclient/icons';
import * as apis from '@truckdown/jsclient/apis';

import proImg from '../Images/td_badge_pro.png';
import eliteImg from '../Images/td_badge_elite.png';


interface Feature {
    name: string,
    description: string,
    guest: {
        text?: string,
        icon?: string[]
    },
    free: {
        text?: string,
        icon?: string[]
    },
    fleet: {
        text?: string,
        icon?: string[]
    }
}

interface Features {
    id: number,
    features: Feature[]
}

interface NavItem {
    name: string,
    description: string,
    icon: string
}


export default defineComponent({
    props: {
        navItems: {
            type: Array as () => NavItem[],
            required: true
        },
        features: {
            type: Array as () => Features[],
            required: true
        }
    },
    setup: function (props, ctx) {

        let tableHeading = ref<string>(props.navItems[0].name);
        const isActive = ref<Boolean[]>([true, false, false, false]);
        const navItems = ref<NavItem[]>(props.navItems);

        let features = ref<Feature[]>(props.features[0].features);

        const toggleActive = async function (index: number) {
            isActive.value = [false, false, false, false];
            isActive.value[index] = !isActive.value[index];
            // Use nextTick to wait for class update before calculating height
            await nextTick();
            switch (index) {
                case 0:
                    tableHeading.value = props.navItems[0].name;
                    features.value = props.features[0].features;
                    break;

                case 1:
                    tableHeading.value = props.navItems[1].name;
                    features.value = props.features[1].features;
                    break;

                case 2:
                    tableHeading.value = props.navItems[2].name;
                    features.value = props.features[2].features || [];
                    break;
                case 3:
                    tableHeading.value = props.navItems[3].name;
                    features.value = props.features[3].features || [];
                    break;
                case 4:
                    break;
            }
            updateHeight();
        }

        const shouldShowCallToAction = function (type: string) {
            if (sys.framework.context.isAuthenticated() && type == 'free') {
                return false;
            }
            if (sys.framework.context.isInRole(apis.framework.SecurityConstants.Roles.FleetUserRole) && type == 'fleet' ) {
                return false;
            }
            return true;
        }

        const callToAction = function (type: string) {
            console.log('Action: ' + type);
            //stock, pro, elite, promotion
            if (type == 'stock'
                || type == 'pro'
                || type == 'elite'
                || type == 'promotion') {
                if (sys.framework.context.isAuthenticated()) {
                    window.location.href = "/listings";
                } else {
                    window.location.href = "/accounts/create-or-signin?returnUrl=%2Flistings";
                }
            } else if (type == 'fleet') {
                if (sys.framework.context.isAuthenticated()) {
                    window.location.href = "/accounts/fleet-upgrade";
                } else {
                    window.location.href = "/accounts/create-or-signin";
                }
            } else if (type == 'free') {
                window.location.href = "/accounts/create-or-signin";
            } else if (type = 'protection') {
                if (sys.framework.context.isAuthenticated()) {
                    window.location.href = "/accounts/fleet-upgrade";
                } else {
                    window.location.href = "/accounts/create-or-signin?returnUrl=%2Faccounts%2Ffleet-upgrade";
                }
            }
        }

        const callToActionTitle = function (type: string) {
            if (type == 'stock'
                || type == 'pro'
                || type == 'elite'
                || type == 'promotion') {
                if (sys.framework.context.isAuthenticated()) {
                    return 'Manage Listings';
                } else {
                    return 'Create Vendor Account';
                }
            }
            if (type == 'fleet' || type == 'free') {
                if (sys.framework.context.isAuthenticated()) {
                    return 'Upgrade Account';
                } else {
                    return 'Create Account';
                }
            }
            if (type == 'protection') {
               return "Manage Listings"
            }
            return '';
        }

        const callToActionLabel = function (type: string) {
            if (type == 'stock') {
                return 'FREE';
            }
            if (type == 'pro') {
                return '$330 / YEAR';
            }
            if (type == 'elite') {
                return '$660 / YEAR';
            }
            if (type == 'promotion') {
                return 'Click to get started';
            }
            if (type == 'fleet') {
                if (sys.framework.context.isAuthenticated()) {
                    return 'Upgrade Account';
                } else {
                    return 'Create Account';
                }
            }
            if (type == 'free') {
                return 'Create Account';
            }
            if (type == 'protection') {
                return "Click To Get Started"
            }
            return '';
        }

        const height = ref<number>(0);

        const updateHeight = () => {
            const myDiv = document.querySelector('.nav-active');
            if (myDiv) {
                height.value = myDiv.getBoundingClientRect().height;
            }
        };

        // Call updateHeight when the component is mounted and when the window is resized
        window.addEventListener('resize', updateHeight);

        // Use a computed property to calculate the CSS height variable
        const style = computed(() => {
            return { '--height': `${height.value}px` };
        });

        const isPathIncludesShopFleets = function (): boolean {
            const currentPath: string = window.location.pathname;
            return currentPath.includes('shop/fleets');
        }

        onMounted(() => {
            toggleActive(0);
            window.addEventListener('resize', updateHeight);
        })

        onBeforeUnmount(() => {
            window.removeEventListener('resize', updateHeight);
        });

        watch(height, () => {
            updateHeight();
        });

        return {
            features,
            isActive,
            toggleActive,
            navItems,
            tableHeading,
            proImg,
            eliteImg,
            style,
            callToAction,
            callToActionLabel,
            callToActionTitle,
            shouldShowCallToAction,
            isPathIncludesShopFleets
        }
    }
});

